<common-modal
  *ngIf="isOpen"
  [isOpen]="isOpen"
  (isOpenChange)="isOpenChange.emit($event)"
  size="md"
  position="center"
>
  <ng-container header>
    <h2>{{ 'executionModal.title' | translate }}</h2>
  </ng-container>
  <ng-container body>
    <div *ngIf="step !== undefined" class="flex flex-col">
      <ng-container *ngIf="waitForQuoteRefresh">
        <div
          class="border-2 border-orange-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-orange rounded-full animate-pulse"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.waitForQuoteRefresh.info' | translate
            }}</span>
          </div>
        </div>
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
      </ng-container>
      <div
        class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
      >
        <div
          class="w-3 h-3 rounded-full"
          [class.bg-gray-300]="step <= Step.SIMULATE"
          [class.bg-green-300]="step > Step.SIMULATE"
          [class.animate-pulse]="step === Step.SIMULATE"
        ></div>
        <div class="ml-4 flex flex-col">
          <span class="text-gray-400">{{
            'executionModal.step.simulate.info' | translate
          }}</span>
          <span class="text-xs text-gray-400">{{
            'executionModal.step.simulate.desc' | translate
          }}</span>
        </div>
      </div>
      <ng-container *ngIf="failedStep === Step.SIMULATE">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-red-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-red rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <div class="flex flex-row">
              <span class="text-gray-400">{{
                'executionModal.step.simulate.failed.info' | translate
              }}</span>
              <a
                [href]="getTenderlySimulationLink()"
                [floatUi]="getTenderlySimulationLink()"
                target="_blank"
                class="flex items-center rounded-lg button-white hover:!bg-gray p-1 px-2"
              >
                <img
                  alt="Tenderly logo"
                  class="h-[18px]"
                  src="assets/images/external-logos/tenderly.png"
                />
              </a>
            </div>
            <div class="flex flex-col">
              <span class="text-xs text-gray-400">{{
                'executionModal.step.simulate.failed.desc' | translate
              }}</span>
              <div class="mt-2 w-full flex flex-row items-center">
                <button (click)="onExecuteAfterRefreshClick()" class="button">
                  {{
                    'executionModal.action.executeWithQuoteRefresh' | translate
                  }}
                </button>
                <button (click)="onRecalculateClick()" class="button ml-2">
                  {{ 'executionModal.action.recalculate' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="executionState.isGasRelayerTx">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
          [class.opacity-30]="step < Step.PREPARE_RELAYER_REQUEST"
        >
          <div
            class="w-3 h-3 rounded-full"
            [class.bg-gray-300]="step <= Step.PREPARE_RELAYER_REQUEST"
            [class.bg-green-300]="step > Step.PREPARE_RELAYER_REQUEST"
            [class.animate-pulse]="step === Step.PREPARE_RELAYER_REQUEST"
          ></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.prepareRelayerRequest.info' | translate
            }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          failedStep === Step.PREPARE_RELAYER_REQUEST ||
          failedStep === Step.REQUEST_TX_FROM_RELAYER
        "
      >
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-red-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-red rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.prepareRelayerRequest.failed.info'
                | translate
            }}</span>
            <div class="flex flex-col">
              <span class="text-xs text-gray-400">{{
                'executionModal.step.prepareRelayerRequest.failed.desc'
                  | translate
              }}</span>
              <div class="mt-2 w-full flex flex-row items-center">
                <button (click)="onExecuteWithWalletClick()" class="button">
                  {{ 'executionModal.action.executeWithWallet' | translate }}
                </button>
                <button (click)="onRecalculateClick()" class="button ml-2">
                  {{ 'executionModal.action.recalculate' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
          [class.opacity-30]="step < Step.USER_SIGN"
        >
          <div
            class="w-3 h-3 rounded-full"
            [class.bg-gray-300]="step <= Step.USER_SIGN"
            [class.bg-green-300]="step > Step.USER_SIGN"
            [class.animate-pulse]="step === Step.USER_SIGN"
          ></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.userSign.info' | translate
            }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="failedStep === Step.USER_SIGN">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-red-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-red rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.userSign.failed.info' | translate
            }}</span>
            <div class="flex flex-col">
              <span class="text-xs text-gray-400">{{
                'executionModal.step.userSign.failed.desc' | translate
              }}</span>
              <div class="mt-2 w-full flex flex-row items-center">
                <button (click)="onExecuteClick()" class="button">
                  {{ 'executionModal.action.execute' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="executionState.isGasRelayerTx">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
          [class.opacity-30]="step < Step.REQUEST_TX_FROM_RELAYER"
        >
          <div
            class="w-3 h-3 rounded-full"
            [class.bg-gray-300]="step <= Step.REQUEST_TX_FROM_RELAYER"
            [class.bg-green-300]="step > Step.REQUEST_TX_FROM_RELAYER"
            [class.animate-pulse]="step === Step.REQUEST_TX_FROM_RELAYER"
          ></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.requestTxFromRelayer.info' | translate
            }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
          [class.opacity-30]="step < Step.BROADCAST"
        >
          <div
            class="w-3 h-3 rounded-full"
            [class.bg-gray-300]="step <= Step.BROADCAST"
            [class.bg-green-300]="step > Step.BROADCAST"
            [class.animate-pulse]="step === Step.BROADCAST"
          ></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.broadcast.info' | translate
            }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="failedStep === Step.BROADCAST">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-red-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-red rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.broadcast.failed.info' | translate
            }}</span>
            <div class="flex flex-col">
              <span class="text-xs text-gray-400">{{
                'executionModal.step.requestTxFromRelayer.failed.desc'
                  | translate
              }}</span>
              <div class="mt-2 w-full flex flex-row items-center">
                <button (click)="onExecuteAfterRefreshClick()" class="button">
                  {{
                    'executionModal.action.executeWithQuoteRefresh' | translate
                  }}
                </button>
                <button (click)="onRecalculateClick()" class="button ml-2">
                  {{ 'executionModal.action.recalculate' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container>
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-gray-800 rounded bg-gray-900 flex px-4 py-1 items-center"
          [class.opacity-30]="step < Step.PROCESS"
        >
          <div
            class="w-3 h-3 rounded-full"
            [class.bg-gray-300]="step <= Step.PROCESS"
            [class.bg-green-300]="step > Step.PROCESS"
            [class.animate-pulse]="step === Step.PROCESS"
          ></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.process.info' | translate
            }}</span>
            <ng-container *ngTemplateOutlet="txHash"></ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="step === Step.SUCCESS">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-green-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-green rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.success.info' | translate
            }}</span>
            <ng-container *ngTemplateOutlet="txHash"></ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="step === Step.SUCCESS_PARTLY">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-green-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-orange rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.successPartly.info' | translate
            }}</span>
            <span class="text-xs text-gray-400">{{
              'executionModal.step.successPartly.desc' | translate
            }}</span>
            <ng-container *ngTemplateOutlet="txHash"></ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="step === Step.ERROR">
        <div class="flex justify-center">
          <div class="w-0.5 h-4 bg-gray-800"></div>
        </div>
        <div
          class="border-2 border-red-300 rounded bg-gray-900 flex px-4 py-1 items-center"
        >
          <div class="w-3 h-3 bg-red rounded-full"></div>
          <div class="ml-4 flex flex-col">
            <span class="text-gray-400">{{
              'executionModal.step.error.info' | translate
            }}</span>
            <ng-container *ngTemplateOutlet="txHash"></ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container footer>
    <button (click)="onCloseClick()" class="button-white mb-2 md:mb-0">
      {{ 'global.close' | translate }}
    </button>
    <button (click)="onMakeNewTradeClick()" class="button mb-2 md:mb-0">
      {{ 'rebalancing.makeNewTrade' | translate }}
    </button>
  </ng-container>
</common-modal>

<ng-template #txHash>
  <div *ngIf="executionState.transaction" class="flex flex-row items-center">
    <span
      class="text-xs text-gray-400"
      [floatUi]="executionState.transaction.hash"
      >Hash: {{ getShortDisplayAddress(executionState.transaction.hash) }}</span
    >
    <a
      (click)="copyToClipboard(executionState.transaction.hash)"
      [floatUi]="'global.copy' | translate"
      class="flex items-center rounded-lg button-white hover:!bg-gray p-1 px-2 ml-2 cursor-pointer"
    >
      <ng-icon name="hero-clipboard-mini" size="14"></ng-icon>
    </a>
    <a
      [href]="getBlockExplorerLink()"
      [floatUi]="getBlockExplorerLink()"
      target="_blank"
      class="flex items-center rounded-lg button-white hover:!bg-gray p-1 px-2"
    >
      <ng-icon name="hero-arrow-top-right-on-square-mini" size="14"></ng-icon>
    </a>
    <a
      [href]="getTenderlyLink()"
      [floatUi]="getTenderlyLink()"
      target="_blank"
      class="flex items-center rounded-lg button-white hover:!bg-gray p-1 px-2"
    >
      <img
        alt="Tenderly logo"
        class="h-[18px]"
        src="assets/images/external-logos/tenderly.png"
      />
    </a>
  </div>
</ng-template>
